<template>
  <div class="row" style="margin-top:10px;">
    <div class="linkBox">
      <div class="box_title" style="margin-bottom: 10px;">
        <span class="title">相关链接</span>
      </div>
      <div style="border:1px solid #ccc;display:flex;justify-content:space-around;">
        <a href="http://www.mot.gov.cn/">中华人民共和国交通运输部</a>
        <a href="http://jtyst.nmg.gov.cn/">内蒙古自治区交通运输厅</a>
        <a href="http://www.ordos.gov.cn/">鄂尔多斯市人民政府</a>
        <a href="http://xxgk.ordos.gov.cn/">鄂尔多斯市信息公开发布平台</a>
        <a href="http://zwfw.ordos.gov.cn/">鄂尔多斯政府服务网</a>
      </div>
      <!-- <div class="boxSelect">
        <select
          class="select"
          name="slt260"
          onchange="if(this.options[this.selectedIndex].value!=&quot;#&quot;) window.open(this.options[this.selectedIndex].value,&quot;&quot;,&quot;&quot;);"
        >
          <option value="#">区属各机关行政单位</option>
          <option value="http://jwjcj.shunde.gov.cn/">区纪委机关（区监察局）</option>
          <option value="http://www.shunde.gov.cn/sfb">区委区政府办公室</option>
          <option value="http://zzb.shunde.gov.cn/">区委组织部</option>
          <option value="http://www.shunde.gov.cn/xcb">区委宣传部（区文化体育局））</option>
          <option value="http://www.shunde.gov.cn/zfsf">区委政法委员会（区司法局）</option>
          <option value="http://www.shunde.gov.cn/sdshgz">区委统一战线工作部（区外事侨务局）</option>
          <option value="http://www.shunde.gov.cn/sg">区发展规划和统计局</option>
          <option value="http://www.shunde.gov.cn/est">区经济和科技促进局</option>
          <option value="http://www.shunde.gov.cn/jyj">区教育局</option>
          <option value="http://www.shunde.gov.cn/gongan">区公安局</option>
          <option value="http://www.shunde.gov.cn/sdcz">区财税局</option>
          <option value="http://www.shunde.gov.cn/hrss">区民政和人力资源社会保障局</option>
          <option value="http://www.shunde.gov.cn/gtcjsl">区国土城建和水利局</option>
          <option value="http://www.shunde.gov.cn/wsjs">区卫生和计划生育局</option>
          <option value="http://www.shunde.gov.cn/sdaudit">区审计局</option>
          <option value="http://www.shunde.gov.cn/nyj">区农业局</option>
          <option value="http://www.shunde.gov.cn/scaj">区市场监督管理局</option>
          <option value="http://www.shunde.gov.cn/hycg">区环境运输和城市管理局</option>
          <option value="http://sdfy.shunde.gov.cn/">区人民法院</option>
          <option value="http://www.shunde.gov.cn/">区人民检察院</option>
          <option value="http://xfj.shunde.gov.cn/">区信访局</option>
          <option value="http://www.shunde.gov.cn/sfb/page.php?singleid=7">区国家保密局</option>
          <option value="http://www.shunde.gov.cn/gzb">区国有资产监督管理办公室</option>
          <option value="http://www.shunde.gov.cn/sdgyj">区公用事业管理局</option>
          <option value="http://www.shunde.gov.cn/gdsdsi/">顺德区社会保险基金管理局</option>
          <option value="http://www.shunde.gov.cn/xzfwzx">区行政服务中心</option>
          <option value="http://www.shunde.gov.cn/da">区档案局</option>
          <option value="http://www.sdip.gov.cn">顺德高新技术产业开发区管委会</option>
          <option value="http://djjy.shunde.gov.cn">区房地产交易登记中心</option>
          <option value="http://sdcin.shunde.gov.cn/">区建设工程交易中心</option>
          <option value="http://sdcin.shunde.gov.cn/">顺德区公共资源交易中心</option>
          <option value="http://www.sdrc.gov.cn">人才交流中心</option>
          <option value="http://www.sd.gdciq.gov.cn">顺德出入境检验检疫局</option>
          <option value="http://www.fsgjj.gov.cn/">市住房公积金管理中心</option>
        </select>
        <select
          class="select"
          name="slt291"
          onchange="if(this.options[this.selectedIndex].value!=&quot;#&quot;) window.open(this.options[this.selectedIndex].value,&quot;&quot;,&quot;&quot;);"
        >
          <option value="#">各镇、街道办</option>
          <option value="http://www.shunde.gov.cn/daliang">大良街道办事处</option>
          <option value="http://www.shunde.gov.cn/ronggui">容桂街道办事处</option>
          <option value="http://www.shunde.gov.cn/lunjiao">伦教街道办事处</option>
          <option value="http://www.shunde.gov.cn/leliu">勒流街道办事处</option>
          <option value="http://www.shunde.gov.cn/chencun">陈村镇政府</option>
          <option value="http://www.shunde.gov.cn/beijiao">北滘镇政府</option>
          <option value="http://www.shunde.gov.cn/lecong">乐从镇政府</option>
          <option value="http://www.shunde.gov.cn/longjiang">龙江镇政府</option>
          <option value="http://www.shunde.gov.cn/xingtan">杏坛镇政府</option>
          <option value="http://www.shunde.gov.cn/jun-an">均安镇政府</option>
        </select>
        <select
          class="select"
          name="slt471"
          onchange="if(this.options[this.selectedIndex].value!=&quot;#&quot;) window.open(this.options[this.selectedIndex].value,&quot;&quot;,&quot;&quot;);"
        >
          <option value="#">国内门户</option>
          <option value="http://www.xinhuanet.com">新华社</option>
          <option value="http://www.peopledaily.com.cn">人民日报</option>
          <option value="http://www.gzdaily.com">广州日报</option>
          <option value="http://www.nanfangdaily.com.cn">南方日报</option>
          <option value="http://www.163.com">网易</option>
          <option value="http://www.sohu.com">搜狐</option>
          <option value="http://www.sina.com">新浪</option>
          <option value="http://www.cctv.com">央视国际</option>
          <option value="http://www.21cn.com">二十一世纪</option>
          <option value="http://www.gznet.com">广州视窗</option>
          <option value="http://www.tom.com">TOM.COM</option>
        </select>
        <select
          class="select"
          name="slt107"
          onchange="if(this.options[this.selectedIndex].value!=&quot;#&quot;) window.open(this.options[this.selectedIndex].value,&quot;&quot;,&quot;&quot;);"
        >
          <option value="#">友情网站</option>
          <option value="http://www.foshanepb.gov.cn/">佛山市环境保护局</option>
          <option value="http://hbj.chancheng.gov.cn/">禅城区环保局</option>
          <option value="http://hbj.gaoming.gov.cn/">高明区环保局</option>
          <option value="http://hb.ss.gov.cn/">三水区环保局</option>
          <option value="http://huanbao.nanhai.gov.cn/">南海区环保局</option>
          <option value="http://www.zhb.gov.cn/">国家环境保护总局</option>
          <option value="http://www.gdepb.gov.cn/">广东环保</option>
          <option value="http://www.gzepb.gov.cn/">广州环保</option>
          <option value="http://www.szepb.gov.cn/">深圳市环保</option>
          <option value="http://www.zsepb.gov.cn/">中山市环境保护局</option>
          <option value="http://www.hyenv.gnet.gd.cn/">广东河源市环保局</option>
          <option value="http://www.stepb.gov.cn/">汕头市环境保护局</option>
          <option value="http://www.zqepb.com/">肇庆市环境保护局</option>
          <option value="http://jmepb.jiangmen.gd.cn/">江门市环保</option>
          <option value="http://www.zhepb.gov.cn/">珠海市环保</option>
          <option value="http://www.fsjtw.gov.cn">佛山交通局</option>
          <option value="http://jt.nanhai.gov.cn">南海区交通局</option>
          <option value="http://www.gmc.gov.cn">高明区交通局</option>
          <option value="http://jt.ss.gov.cn">三水区交通局</option>
          <option value="http://jtj.dg.gov.cn">东莞市交通局公众网站</option>
          <option value="http://jiaotong.kaiping.gov.cn">开平市交通局</option>
          <option value="http://www.zqjt.gov.cn">肇庆交通局公众网</option>
          <option value="http://www.zhjt.gov.cn">珠海市交通局</option>
          <option value="http://www.xinhui.gd.cn/xhjtj">新会市交通局</option>
          <option value="http://www.qjjt.com">曲江县交通局</option>
          <option value="http://jiaotong.enping.gov.cn">恩平市交通局</option>
          <option value="http://jiaotong.huizhou.gov.cn/">惠州市交通局</option>
          <option value="http://www.sztb.gov.cn/">深圳市交通局</option>
          <option value="http://www.gzci.com.cn">广州交通信息网</option>
          <option value="http://www.ntcccg.com/">南通市崇川城市管理行政执法局</option>
          <option value="http://www.hangzhou.gov.cn/">杭州市城市管理行政执法局</option>
          <option value="http://www.nnszgl.gov.cn/">南宁市城市管理综合执法局</option>
          <option value="http://www.szum.gov.cn/">深圳城管</option>
          <option value="http://www.gzcg.gov.cn/">广州城管</option>
          <option value="http://www.fscgb.gov.cn/">佛山市城市管理行政执法局</option>
          <option value="http://www.cczf.gov.cn/">禅城区城市管理行政执法局</option>
          <option value="http://shizheng.nanhai.gov.cn/">南海区城市管理行政执法局</option>
          <option value="http://xzzf.gaoming.gov.cn/">高明区城市管理行政执法局</option>
          <option value="http://zfj.ss.gov.cn/">三水区城市管理行政执法局</option>
          <option value="http://www.shundecity.com/">顺德城市网</option>
        </select>
      </div> -->
    </div>
    <!-- <div class="col-md-3"></div>
    <div class="col-md-3"></div>
    <div class="col-md-3"></div>
    <div class="col-md-3"></div>-->
  </div>
</template>
<script>
export default {
  name: "index"
};
</script>
<style scoped>
.row {
  padding: 5px 5px 0 5px;
}
.linkBox {
  /* border: 1px solid rebeccapurple; */
  padding-bottom: 30px;
  width: 100%;
  padding-left: 5px;
}
.box_title .title {
  color: #0098fb;
  padding: 2px 2px 5px;
  border-bottom: 2px solid #0098fb;
  font-weight: 700;
  font-size: 14px;
}
.boxSelect {
  display: flex;
  justify-content: flex-start;
  /* padding-left: 5px; */
}
.select {
  width: 40%;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  color: #000;
  height: 25px;
  line-height: 25px;
  margin-right: 60px;
}
</style>





// WEBPACK FOOTER //
// src/components/relatedlink/index.vue